import { render, staticRenderFns } from "./logoSmall.vue?vue&type=template&id=5d14ca4e&"
import script from "./logoSmall.vue?vue&type=script&lang=js&"
export * from "./logoSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports